import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';
import { ExpandableBottomCard } from '@app/ui/';
import moment from 'moment';
import DateRangePicker from '../../components/common/DateRangePicker';
import searchGrayIcon from '../../images/common/search-gray.svg';

import {
  fetchClaims,
  fetchClaimsFilters,
  getAllRelatives,
} from '../../services';
import {
  FadeInTransition,
  FlyInTransition,
} from '../../components/transitions/transitions';
import Header from '../../components/common/Header';
import LoadingComponent from '../../components/common/LoadingComponent';
import ClaimsStatusCard from '../../components/claims/NewClaimsStatusCard';
import { logEvent } from '../../utils/logEvent';
import HospitalizationModal from '../../containers/common/HospitalizationModal';
import Modal from '../../containers/common/Modal';
import NoClaimsImage from '../../images/policy/NoClaimsFound.svg';
import { ReactComponent as SlidersHorizontal } from '@web/images/common/sliders-horizontal.svg';
import { ReactComponent as ArrowSwap } from '@web/images/common/arrow-swap.svg';

import ClaimFeedbackBottomSheet from '../../components/claims/ClaimFeedbackBottomSheet';
import { submitClaimReview, getPendingFeedback } from '../../services/claims';
const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  overflow: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 16px;
  background: #f4f4f7;
`;

const HospitalizationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  height: 100svh;
  width: 100vw;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 14px;
  margin-top: 8px;
  margin-bottom: 8px;
  color: #8e8f91;
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #0f0b28;

  &::placeholder {
    color: #8e8f91;
  }
`;

const SortOptionsList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

const SortOptionRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 24px;
  border: none;
  background: ${({ selected }) => (selected ? '#f3f2ff' : '#ffffff')};
  font-size: 14px;
  font-weight: 400;
  color: #0f0b28;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease-in-out;
`;

const SortRadio = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid ${({ selected }) => (selected ? '#714fff' : '#c4c4c4')};
  background: #ffffff;
  flex-shrink: 0;
  transition: 0.15s ease-in-out;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #714fff;
    transform: scale(${({ selected }) => (selected ? 1 : 0)});
    transition: transform 0.15s ease-in-out;
  }
`;

const FiltersBody = styled.div`
  display: flex;
  height: 360px;
`;

const FiltersTabs = styled.div`
  width: 40%;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const FilterTab = styled.button`
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  border: none;
  background: ${({ active }) => (active ? '#F5F2FF' : 'transparent')};
  border-left: ${({ active }) => (active ? '2px solid #714fff' : '')};
  color: ${({ active }) => (active ? '#714fff' : '#0f0b28')};
  font-size: 12px;
  font-weight: ${({ active }) => (active ? 600 : 500)};
  cursor: pointer;
  transition: 0.15s ease-in-out;
`;

const FilterTabCount = styled.span`
  color: #714fff;
  margin-left: 4px;
`;

const FiltersOptions = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  background: #ffffff;
`;

const FilterOption = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 8px;
  text-align: left;
  border: 1px solid ${({ selected }) => (selected ? '#714fff' : '#e5e7eb')};
  background: ${({ selected }) => (selected ? '#f3f2ff' : '#ffffff')};
  color: ${({ selected }) => (selected ? '#714fff' : '#0f0b28')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.15s ease-in-out;
`;

const CheckGlyph = styled.span`
  display: inline-block;
  width: 5px;
  height: 10px;
  border: solid #714fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
`;

const FiltersFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f3f6;
  background: #ffffff;
`;

const ClearAllButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  border: 1.5px solid #d8d7db;
  background: #ffffff;
  color: #0f0b28;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

const ApplyButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  border: none;
  background: #714fff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

// -------------- Constants ----------------------//
const FILTER_GROUP_LABELS = {
  status: 'Claim Status',
  claimType: 'Claim Type',
  policyYear: 'Policy Year',
  dateRange: 'Date Range',
};

const SINGLE_SELECT_FILTER_GROUPS = new Set([
  'relative',
  'dateRange',
  'policyYear',
]);

// -------------- Methods ----------------------//
const buildRelativeGroup = (relatives) => {
  if (!relatives || relatives.length === 0) return null;
  return {
    key: 'relative',
    label: 'Patient',
    options: [
      { key: 'all', label: 'All' },
      { key: 'self', label: 'Self' },
      ...relatives.map((r) => ({
        key: String(r.id),
        label: r.relation ? `${r.name} (${r.relation})` : r.name,
      })),
    ],
  };
};

const buildFilterGroups = (filterConfig, relatives) => {
  const groups = [];
  const relativeGroup = buildRelativeGroup(relatives);
  if (relativeGroup) groups.push(relativeGroup);

  if (!filterConfig) return groups;
  Object.entries(FILTER_GROUP_LABELS).forEach(([apiKey, label]) => {
    const options = filterConfig[apiKey] ?? [];
    if (options.length === 0) return;
    groups.push({
      key: apiKey,
      label,
      options: options.map((o) => ({
        key: o.value || o.procedureId,
        label: o.label || o.procedureName,
      })),
    });
  });
  return groups;
};

const buildSortOptions = (filterConfig) =>
  (filterConfig?.sortBy ?? []).map((o) => ({
    key: o.value,
    label: o.label,
  }));

class ClaimsStart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      verticals: [],
      showVerticalsLeftScroll: false,
      showVerticalsRightScroll: true,
      ongoingClaims: [],
      completedClaims: [],
      cards: [],
      relatives: [],
      showHospitalizationModal: false,
      showCashlessClaimButton: true,
      showReimbusementClaimButton: true,
      showPendingHospilationBlocker: false,
      selectedOption: null,
      showSortingOptions: false,
      searchQuery: '',
      showFilters: false,
      activeFilterTab: null,
      appliedFilters: {},
      draftFilters: {},
      appliedCustomDateRange: null,
      draftCustomDateRange: null,
      filterConfig: null,
      showFeedbackBottomSheet: false,
      feedbackReviewOptions: null,
      feedbackReimbursementId: null,
    };
    this.verticalScrollContainerRef = React.createRef();
  }

  componentDidMount() {
    this.getAllRelatives();
    this.getClaims();
    this.checkForFeedback();
    logEvent('Claims Home Screen');
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.hash === '#profile' &&
      this.props.location.hash !== '#profile'
    ) {
      this.closeProfile();
      return;
    }
  }

  openOrder(order) {
    const { claimId } = order.claimInfo;
    const { history } = this.props;
    history.push('/claims/summary', {
      claimId,
      goBack: true,
      isSPGlobalV2: this.props.location?.isSPGlobalV2,
    });
  }

  getAllRelatives = () => {
    const { authToken } = this.props;
    getAllRelatives(authToken)
      .then((res) => {
        const policyId = res?.userPolicyDetails[0]?.policyId;
        const relatives = [...res.relatives];
        this.setState({
          relatives,
        });
        this.getFilters(policyId);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  getFilters = (policyId) => {
    const { authToken } = this.props;
    fetchClaimsFilters(policyId, authToken)
      .then((res) => {
        this.setState({ filterConfig: res.result });
      })
      .catch((err) => {
        console.error('Error fetching claims filters:', err);
      });
  };

  buildClaimsQuery = (overrides = {}) => {
    const {
      searchQuery,
      selectedOption,
      appliedFilters,
      filterConfig,
      appliedCustomDateRange,
    } = this.state;

    const query = {
      relativeId: appliedFilters.relative?.[0] || 'all',
    };

    if (searchQuery.trim()) query.claimId = searchQuery.trim();
    if (selectedOption) query.sortBy = selectedOption;

    const status = appliedFilters.status;
    if (status?.length) query.filter = status.join(',');

    const claimType = appliedFilters.claimType;
    if (claimType?.length) query.claimType = claimType.join(',');

    if (appliedCustomDateRange?.from && appliedCustomDateRange?.to) {
      query.dateRangeStart = moment(appliedCustomDateRange.from).format(
        'YYYY-MM-DD'
      );
      query.dateRangeEnd = moment(appliedCustomDateRange.to).format(
        'YYYY-MM-DD'
      );
    } else {
      const dateRange = appliedFilters.dateRange?.[0];
      if (dateRange) query.dateRange = dateRange;
    }

    const policyYear = appliedFilters.policyYear?.[0];
    if (policyYear) {
      const opt = (filterConfig?.policyYear ?? []).find(
        (o) => o.value === policyYear
      );
      const start = opt?.startDate ?? opt?.value?.policyYearStart;
      const end = opt?.endDate ?? opt?.value?.policyYearEnd;
      if (start) query.policyYearStart = start;
      if (end) query.policyYearEnd = end;
    }

    return { ...query, ...overrides };
  };

  getClaims(overrides = {}) {
    const { authToken, location, history } = this.props;

    this.setState({ loading: true });
    const query = {
      authToken,
      ...this.buildClaimsQuery(),
      ...overrides,
    };

    fetchClaims(query)
      .then((res) => {
        const cards = res.cards;
        const ongoingClaims = res.claims.filter((claim) => {
          return claim.claimInfo.status.ongoing === true;
        });
        const completedClaims = res.claims.filter((claim) => {
          return claim.claimInfo.status.ongoing === false;
        });

        this.setState(
          {
            completedClaims,
            ongoingClaims,
            cards,
          },
          () => {
            this.setState({ loading: false });
          }
        );

        if (location && location.search) {
          const params = new URLSearchParams(location.search);
          if (params && params.get('requestId')) {
            const requestId = params.get('requestId');
            const claimInfo = res.claims.filter((claim) => {
              return claim.claimInfo.claimId == requestId;
            });
            if (claimInfo && claimInfo.length > 0) {
              history.push('/claims/summary', {
                claimId: requestId,
                goBack: false,
              });
            } else {
              history.push('/home');
            }
          }
        }
      })
      .catch((err) => {
        console.error('Error fetching claims:', err);
        this.setState({
          loading: false,
        });
      })
      .finally(() => {});
  }

  checkForFeedback = () => {
    const { authToken } = this.props;
    getPendingFeedback(authToken)
      .then((res) => {
        if (res.feedbackDue && res.claim) {
          this.setState({
            showFeedbackBottomSheet: true,
            feedbackReviewOptions: res.reviewOptions,
            feedbackReimbursementId: res.claim.reimbursementId,
          });
        }
      })
      .catch(() => {});
  };

  hideModal = () => {
    this.setState({ showHospitalizationModal: false });
  };

  onCardClick = (card) => {
    const { history } = this.props;
    if (card && card.cardType === 'hospitalisation') {
      this.setState({
        showCashlessClaimButton: Boolean(card.canIntimateClaimForPolicy),
        showReimbusementClaimButton: Boolean(card.canSubmitClaimForPolicy),
      });
      this.showHospitalization();
    } else {
      this.setState({
        showCashlessClaimButton: true,
        showReimbusementClaimButton: true,
      });
      if (card.fulfillmentDetailsAvailable) {
        history.push('/reimbursement/preview');
      } else {
        history.push('/reimbursement/fulfillment-details', {
          fulfillmentDetailsAvailable: card.fulfillmentDetailsAvailable,
        });
      }
    }
  };

  showHospitalization(ele) {
    this.setState({
      showHospitalizationModal: true,
      showPendingHospilationBlocker: true,
    });
  }

  handleOutsideClick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return null;
    }
    this.setState({ showPendingHospilationBlocker: false });
  };

  openGmcOrder(order) {
    const { claimId } = order.claimInfo;
    const { history } = this.props;
    history.push('/hospitalization/claim-reimbursement-status', {
      claimId,
      from: 'claims',
    });
  }

  handleSearchChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    this.setState({ searchQuery: value });
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => this.getClaims(), 1000);
  };

  componentWillUnmount() {
    clearTimeout(this.searchDebounceTimer);
  }

  openSortingOptions = () => {
    this.setState({ showSortingOptions: true });
  };

  closeSortingOptions = () => {
    this.setState({ showSortingOptions: false });
  };

  selectSortOption = (key) => {
    this.setState({ selectedOption: key, showSortingOptions: false }, () =>
      this.getClaims()
    );
  };

  openFilters = () => {
    const filterGroups = buildFilterGroups(
      this.state.filterConfig,
      this.state.relatives
    );
    this.setState((prev) => ({
      showFilters: true,
      draftFilters: { ...prev.appliedFilters },
      draftCustomDateRange: prev.appliedCustomDateRange,
      activeFilterTab: filterGroups[0]?.key ?? null,
    }));
  };

  closeFilters = () => {
    this.setState({ showFilters: false });
  };

  setActiveFilterTab = (key) => {
    this.setState({ activeFilterTab: key });
  };

  toggleFilterOption = (groupKey, optionKey) => {
    const isSingleSelect = SINGLE_SELECT_FILTER_GROUPS.has(groupKey);
    this.setState((prev) => {
      const current = prev.draftFilters[groupKey] ?? [];
      const isSelected = current.includes(optionKey);
      let next;
      if (isSingleSelect) {
        next = isSelected ? [] : [optionKey];
      } else {
        next = isSelected
          ? current.filter((k) => k !== optionKey)
          : [...current, optionKey];
      }
      const update = {
        draftFilters: { ...prev.draftFilters, [groupKey]: next },
      };
      if (groupKey === 'dateRange' && next.length > 0) {
        update.draftCustomDateRange = null;
      }
      return update;
    });
  };

  handleCustomDateRangeChange = ({ from, to }) => {
    this.setState((prev) => ({
      draftCustomDateRange: { from, to },
      draftFilters: { ...prev.draftFilters, dateRange: [] },
    }));
  };

  clearAllFilters = () => {
    this.setState({ draftFilters: {}, draftCustomDateRange: null });
  };

  applyFilters = () => {
    this.setState(
      (prev) => ({
        appliedFilters: prev.draftFilters,
        appliedCustomDateRange: prev.draftCustomDateRange,
        showFilters: false,
      }),
      () => this.getClaims()
    );
  };

  render() {
    const {
      cards,
      ongoingClaims,
      completedClaims,
      showHospitalizationModal,
      showPendingHospilationBlocker,
    } = this.state;
    const { history } = this.props;

    const ConsultationCard = (ele) => {
      const type = ele.cardType;
      switch (type) {
        case 'reimbursement-claim':
          return (
            <ClaimsStatusCard
              key={ele.requestId}
              orderRequest={ele}
              onTap={() => this.openOrder(ele)}
            />
          );
        case 'gmc-claim':
          return (
            <ClaimsStatusCard
              key={ele.requestId}
              orderRequest={ele}
              onTap={() => this.openGmcOrder(ele)}
            />
          );
        default:
          return '';
      }
    };
    return (
      <FadeInTransition
        in={true}
        timeout={200}
        mountOnEnter
        unmountOnExit
        appear
      >
        <OuterContainer>
          <Header
            title="My Claims"
            noBorder
            onTap={
              this.props.location?.state?.source === 'new-reimbursement'
                ? () => {
                    if (
                      this.props.location?.state?.source === 'new-reimbursement'
                    ) {
                      history?.replace('/new-reimbursement/preview', {
                        isSPGlobalV2: this.props.location.state?.isSPGlobalV2,
                      });
                    }
                  }
                : null
            }
          ></Header>
          {this.state.loading ? (
            <LoadingComponent />
          ) : (
            <OuterContainer>
              {!!(ongoingClaims.length || completedClaims.length) && (
                <BodyContainer>
                  {cards.map((card, idx) => {
                    return (
                      <div
                        className="blue-box flex-row-center-end mb-12"
                        key={idx}
                        onClick={() => {
                          this.onCardClick(card);
                        }}
                      >
                        <div>
                          <span className="txt-white-600-13">{card.label}</span>
                          <br />
                          <span className="txt-500-white-12">
                            {card.description}
                          </span>
                        </div>
                        <div className="h-100">
                          <span
                            className="vertical-line"
                            style={{ borderColor: '#ffffff' }}
                          />
                          <FaChevronRight />
                        </div>
                      </div>
                    );
                  })}

                  <SearchBar>
                    <img src={searchGrayIcon} alt="" width={20} height={20} />
                    <SearchInput
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      placeholder="Search using Claim ID"
                      value={this.state.searchQuery}
                      onChange={this.handleSearchChange}
                    />
                  </SearchBar>

                  <section className="mt-2 mb-4 flex gap-2 text-taupe-gray text-xs font-medium">
                    <div
                      className="p-2 bg-white rounded-8 cursor-pointer flex"
                      onClick={this.openSortingOptions}
                    >
                      <ArrowSwap className="mr-1" />
                      <span>Sort</span>
                    </div>
                    <div
                      className="p-2 bg-white rounded-8 cursor-pointer flex"
                      onClick={this.openFilters}
                    >
                      <SlidersHorizontal className="mr-1" />
                      <span>Filter</span>
                    </div>
                  </section>

                  {ongoingClaims.length > 0 && (
                    <div>
                      <div className="text-title-s font-semibold p-64px text-txtlight mb-16px mt-8">
                        Ongoing
                      </div>
                      {ongoingClaims.map(ConsultationCard)}
                    </div>
                  )}

                  {completedClaims.length > 0 && (
                    <div>
                      <div className="text-title-s font-semibold p-64px text-txtlight mb-16 mt-8">
                        Completed
                      </div>
                      {completedClaims.map(ConsultationCard)}
                    </div>
                  )}
                </BodyContainer>
              )}
              {ongoingClaims.length === 0 &&
                completedClaims.length === 0 &&
                !this.state.loading && (
                  <BodyContainer>
                    {cards.map((card, idx) => {
                      return (
                        <div
                          className="blue-box flex-row-center-end mb-12"
                          key={idx}
                          onClick={() => {
                            this.onCardClick(card);
                          }}
                          style={{ paddingLeft: '1rem' }}
                        >
                          <div>
                            <span className="txt-white-600-13">
                              {card.label}
                            </span>
                            <br />
                            <span className="txt-500-white-12">
                              {card.description}
                            </span>
                          </div>
                          <div className="h-100">
                            <span
                              className="vertical-line"
                              style={{ borderColor: '#ffffff' }}
                            />
                            <FaChevronRight />
                          </div>
                        </div>
                      );
                    })}
                    <SearchBar>
                      <img src={searchGrayIcon} alt="" width={20} height={20} />
                      <SearchInput
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="Search by claim ID"
                        value={this.state.searchQuery}
                        onChange={this.handleSearchChange}
                      />
                    </SearchBar>

                    <section className="mt-2 mb-4 flex gap-2 text-taupe-gray text-xs font-medium">
                      <div
                        className="p-2 bg-white rounded-8 cursor-pointer flex"
                        onClick={this.openSortingOptions}
                      >
                        <ArrowSwap className="mr-1" />
                        <span>Sort</span>
                      </div>
                      <div
                        className="p-2 bg-white rounded-8 cursor-pointer flex"
                        onClick={this.openFilters}
                      >
                        <SlidersHorizontal className="mr-1" />
                        <span>Filter</span>
                      </div>
                    </section>

                    <div className="flex  flex-col items-center w-full px-20px text-center">
                      <div className="mt-24">
                        <img
                          src={NoClaimsImage}
                          height="200px"
                          width="200px"
                        ></img>
                      </div>
                      <p className="text-body-s font-semibold mt-14">
                        You don't have an ongoing claim request
                      </p>
                      {/* <button
                    onClick={() =>
                      this.props.history.push('/reimbursement/preview')
                    }
                    className="flex w-full py-14px bg-primary justify-center mt-24 rounded-12 text-body-l text-textbox font-semibold"
                  >
                    Claim Now
                  </button> */}
                    </div>
                  </BodyContainer>
                )}
              {showHospitalizationModal && (
                <FlyInTransition>
                  <Modal>
                    <HospitalizationModalContainer
                      onClick={this.handleOutsideClick}
                    >
                      <FadeInTransition
                        in={showPendingHospilationBlocker}
                        mountOnEnter
                        unmountOnExit
                        onExited={this.hideModal}
                        appear
                      >
                        <div
                          ref={(node) => (this.node = node)}
                          className="bg-textbox flex flex-col items-center justify-center rounded-12"
                          style={{ width: '90%', maxWidth: '400px' }}
                        >
                          <HospitalizationModal
                            title={'Hospitalization'}
                            method1={'Claim Reimbursement'}
                            tag1={
                              'Get reimbursed for your previous hospitalisation'
                            }
                            method2={'Cashless Intimation Request'}
                            tag2={'Go cashless for your treatment'}
                            history={this.props.history}
                            showCashlessClaimButton={
                              this.state.showCashlessClaimButton
                            }
                            showReimbusementClaimButton={
                              this.state.showReimbusementClaimButton
                            }
                          />
                        </div>
                      </FadeInTransition>
                    </HospitalizationModalContainer>
                  </Modal>
                </FlyInTransition>
              )}
            </OuterContainer>
          )}

          {this.state.showSortingOptions && (
            <FlyInTransition>
              <ExpandableBottomCard
                open={this.state.showSortingOptions}
                title="Sort By"
                onClose={this.closeSortingOptions}
              >
                <SortOptionsList>
                  {buildSortOptions(this.state.filterConfig).map((option) => {
                    const isSelected = this.state.selectedOption === option.key;
                    return (
                      <SortOptionRow
                        key={option.key}
                        selected={isSelected}
                        onClick={() => this.selectSortOption(option.key)}
                      >
                        <span>{option.label}</span>
                        <SortRadio selected={isSelected} />
                      </SortOptionRow>
                    );
                  })}
                </SortOptionsList>
              </ExpandableBottomCard>
            </FlyInTransition>
          )}

          {this.state.showFilters &&
            (() => {
              const filterGroups = buildFilterGroups(
                this.state.filterConfig,
                this.state.relatives
              );
              const activeGroup =
                filterGroups.find(
                  (g) => g.key === this.state.activeFilterTab
                ) || filterGroups[0];
              return (
                <FlyInTransition>
                  <ExpandableBottomCard
                    open={this.state.showFilters}
                    title="Filters"
                    onClose={this.closeFilters}
                  >
                    <FiltersBody>
                      <FiltersTabs>
                        {filterGroups.map((group) => {
                          const count =
                            this.state.draftFilters[group.key]?.length ?? 0;
                          const active =
                            this.state.activeFilterTab === group.key;
                          return (
                            <FilterTab
                              key={group.key}
                              active={active}
                              onClick={() => this.setActiveFilterTab(group.key)}
                            >
                              {group.label}
                              {count > 0 && (
                                <FilterTabCount>({count})</FilterTabCount>
                              )}
                            </FilterTab>
                          );
                        })}
                      </FiltersTabs>
                      <FiltersOptions>
                        {activeGroup?.key === 'dateRange' && (
                          <DateRangePicker
                            value={this.state.draftCustomDateRange}
                            onChange={this.handleCustomDateRangeChange}
                          />
                        )}
                        <div
                          className={`flex gap-2 ${activeGroup?.key === 'dateRange' ? 'flex-wrap' : 'flex-col'}`}
                        >
                          {(activeGroup?.options ?? []).map((option) => {
                            const selectedSet =
                              this.state.draftFilters[activeGroup?.key] ?? [];
                            const isSelected = selectedSet.includes(option.key);
                            return (
                              <FilterOption
                                key={option.key + ' ' + Math.random()}
                                selected={isSelected}
                                onClick={() =>
                                  activeGroup &&
                                  this.toggleFilterOption(
                                    activeGroup.key,
                                    option.key
                                  )
                                }
                              >
                                <span>{option.label}</span>
                                {isSelected && <CheckGlyph className="ml-3" />}
                              </FilterOption>
                            );
                          })}
                        </div>
                      </FiltersOptions>
                    </FiltersBody>
                    <FiltersFooter>
                      <ClearAllButton onClick={this.clearAllFilters}>
                        Clear All
                      </ClearAllButton>
                      <ApplyButton onClick={this.applyFilters}>
                        Apply
                      </ApplyButton>
                    </FiltersFooter>
                  </ExpandableBottomCard>
                </FlyInTransition>
              );
            })()}
          <ClaimFeedbackBottomSheet
            visible={this.state.showFeedbackBottomSheet}
            onClose={() => this.setState({ showFeedbackBottomSheet: false })}
            reviewOptions={this.state.feedbackReviewOptions}
            reimbursementId={this.state.feedbackReimbursementId}
            entryPoint="my_claims"
            onSubmitReview={async (body) => {
              await submitClaimReview(body, this.props.authToken);
              this.checkForFeedback();
            }}
          />
        </OuterContainer>
      </FadeInTransition>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  user: state.user,
});

export default connect(mapStateToProps)(ClaimsStart);
